import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService, private router:Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            if (err.status === 401) {
                this.authenticationService.logout();
                location.reload();
            }
            if (err.status === 403) {
                this.router.navigate(['/forbidden']);
            }
            
            const error = err?.error?.msg 
                        || err?.error?.message 
                        || err?.statusText 
                        || 'Unknown error';
            return throwError(error);
        }))
    }
}
